var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".datePicker[data-v-86efe68c] {\n  width: 100% !important;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _xlsx = require("xlsx");

var _xlsx2 = _interopRequireDefault(_xlsx);

var _vue2Datepicker = require("vue2-datepicker");

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["default_currency", "currencies", "services", "merchants", "bank_accounts", "items_url", "current_user_id", "merchant_ids"],
  components: { DatePicker: _vue2Datepicker2.default },
  data: function data() {
    var _ref;

    return _ref = {
      loading: false,
      settlement_records: [],
      service_name: null,
      service: "",
      total_pages: 0,
      total_entries: 0,
      current_page: 1,
      page_size: 0,
      status: "",
      currency: "",
      all_currencies: [],
      all_services: [],
      merchantsList: [],
      bank_account_id: null,
      date_range: null,
      merchant_id: null,
      service_id: null,
      reference: null
    }, (0, _defineProperty3.default)(_ref, "loading", false), (0, _defineProperty3.default)(_ref, "filters", {}), (0, _defineProperty3.default)(_ref, "collection_summary", {
      collected: {
        usd_revenue: 0,
        other_revenue: 0,
        usd_applications: 0,
        other_applications: 0
      },
      settled: {
        usd_revenue: 0,
        other_revenue: 0,
        usd_applications: 0,
        other_applications: 0
      },
      pending: {
        usd_revenue: 0,
        other_revenue: 0,
        usd_applications: 0,
        other_applications: 0
      }
    }), _ref;
  },

  computed: {
    can_download: function can_download() {
      if (this.settlement_records.length > 0) return true;
      return false;
    }
  },
  mounted: function mounted() {
    this.all_currencies = JSON.parse(this.currencies);
    this.all_services = JSON.parse(this.services);
    this.merchantsList = JSON.parse(this.merchants);
    this.loading = true;

    this.fetch_settlement_records(this.current_page);
  },

  methods: {
    search: function search() {
      this.fetch_settlement_records(this.current_page);
    },
    get_view: function get_view(id) {
      return "/settlements/" + id + "/details";
    },

    fetch_collection_summary: function fetch_collection_summary() {
      var _this = this;

      console.log(this.merchant_ids);
      var auth_url = "/api/settlements/dashboard/data?merchant_ids=" + JSON.parse(this.merchant_ids);
      this.loading = true;
      _axios2.default.get(auth_url).then(function (response) {
        _this.loading = false;
        _this.collection_summary = response.data.collection_summary;
      }).catch(function () {
        _this.loading = false;
      });
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    to_human: function to_human(x) {
      if (x == null) return 0;
      var n = this.to_fixed(x);
      return this.formatNumber(n.toLocaleString());
    },
    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },

    fetch_settlement_records: function fetch_settlement_records(page) {
      var _this2 = this;

      var auth_url = "/api/settlements/batch/list";
      this.loading = true;
      Vue.axios.get(auth_url, {
        params: {
          s: this.service_name,
          page: page,
          status: this.status,
          currency: this.currency,
          service_id: this.service_id,
          merchant_id: this.merchant_id,
          bank_account_id: this.bank_account_id,
          date_range: this.date_range,
          current_user_id: this.current_user_id,
          reference: this.reference
        }
      }).then(function (response) {
        _this2.all_services = response.data.merchant_services;
        _this2.loading = false;
        _this2.settlement_records = response.data.entries;
        _this2.total_pages = response.data.total_pages;
        _this2.total_entries = response.data.total_entries;
        _this2.current_page = response.data.page_number;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    applyFilter: function applyFilter() {},
    download_statement: async function download_statement() {
      var resp = await _axios2.default.get("/api/settlements/batch/list", {
        params: {
          s: this.service_name,
          page: this.current_page,
          status: this.status,
          currency: this.currency,
          service_id: this.service_id,
          merchant_id: this.merchant_id,
          bank_account_id: this.bank_account_id,
          paginate: false,
          date_range: this.date_range
        }
      });
      var data = resp.data.map(function (item) {
        return {
          "ID": item.id,
          Reference: item.trx_ref,
          "Start Date": item.start_date,
          "End Date": item.end_date,
          merchant: item.services.merchant_name,
          Service: item.services.name,
          "Bank": item.bank,
          "Account Name": item.account_name,
          "Account Number": item.account_number,
          Applications: item.number_of_transactions,
          Currency: item.currency,
          "Gross Amount": item.gross_value,
          "Net Amount": item.amount,
          Commission: item.commission,
          Status: item.status,
          "Date Submitted": item.inserted_at,
          "Date Settled": item.updated_at,
          "Payment Methods": item.payment_methods
        };
      });
      var worksheet = _xlsx2.default.utils.json_to_sheet(data);
      var workbook = _xlsx2.default.utils.book_new();
      _xlsx2.default.utils.book_append_sheet(workbook, worksheet, "Settlement Items");
      var excelBuffer = _xlsx2.default.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      var filename = "settlement_items.xlsx";
      var mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      var blob = new Blob([excelBuffer], { type: mimeType });
      var url = window.URL.createObjectURL(blob);

      var link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"data-toggle":"lists","data-options":"{\"valueNames\": [\"customer-name\", \"customer-id\", \"customer-id\", \"customer-phone\", \"customer-services\", \"customer-lastserved\",\"customer-servedby\"]}"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mb-0"},[_c('select2',{staticClass:"form-control",on:{"change":_vm.search},model:{value:(_vm.merchant_id),callback:function ($$v) {_vm.merchant_id=$$v},expression:"merchant_id"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select by Merchant")]),_vm._v(" "),_vm._l((_vm.merchantsList),function(m){return _c('option',{key:m.id,domProps:{"value":m.id}},[_vm._v("\n                    "+_vm._s(m.name)+"\n                  ")])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mb-0"},[_c('select2',{staticClass:"form-control",on:{"change":_vm.search},model:{value:(_vm.service_id),callback:function ($$v) {_vm.service_id=$$v},expression:"service_id"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select by Service")]),_vm._v(" "),_vm._l((_vm.all_services),function(m){return _c('option',{key:m.id,domProps:{"value":m.id}},[_vm._v("\n                  "+_vm._s(m.name)+"\n                ")])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mb-0"},[_c('select2',{staticClass:"form-control",on:{"change":_vm.search},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select by Currency")]),_vm._v(" "),_vm._l((_vm.all_currencies),function(m){return _c('option',{key:m.id,domProps:{"value":m.symbol}},[_vm._v("\n                  "+_vm._s(m.symbol)+"\n                ")])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mb-0"},[_c('select2',{staticClass:"form-control",on:{"change":_vm.search},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select by Status")]),_vm._v(" "),_c('option',{attrs:{"value":"generated"}},[_vm._v("Generated")]),_vm._v(" "),_c('option',{attrs:{"value":"generated_settlement_inprogress"}},[_vm._v("\n                  Settlement In-Progress\n                ")]),_vm._v(" "),_c('option',{attrs:{"value":"settled"}},[_vm._v("Settled")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mb-0"},[_c('date-picker',{attrs:{"format":"YYYY-MM-DD","confirm":true,"range-separator":"-","value-type":"format","placeholder":"Select date","lang":"en","type":"date","input-class":"form-group mb-0 form-control datePicker","append_to_body":true,"range":true,"shortcuts":false},on:{"clear":_vm.applyFilter,"change":_vm.fetch_settlement_records},model:{value:(_vm.date_range),callback:function ($$v) {_vm.date_range=$$v},expression:"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mb-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reference),expression:"reference"}],staticClass:"form-control",attrs:{"placeholder":"Reference"},domProps:{"value":(_vm.reference)},on:{"change":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.reference=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col"},[(_vm.can_download)?_c('div',{staticClass:"form-group mb-0"},[_c('button',{staticClass:"btn btn-sm btn-outline-success",on:{"click":_vm.download_statement}},[_c('span',{staticClass:"iconify",attrs:{"data-icon":"fa:file-excel-o","data-inline":"false"}}),_vm._v("\n                Download\n              ")])]):_vm._e()])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"table-responsive"},[_c('br'),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-nowrap card-table"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.settlement_records),function(item,index){return _c('tbody',{key:index,staticClass:"list"},[_c('tr',[_c('td',{staticClass:"customer-id"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                  "+_vm._s(item.id)+"\n                ")])]),_vm._v(" "),_c('td',{staticClass:"customer-id"},[_c('a',{attrs:{"href":_vm.get_view(item.id)}},[_vm._v("\n                  "+_vm._s(item.trx_ref)+"\n                ")])]),_vm._v(" "),_c('td',{staticClass:"customer-id"},[_c('time',{attrs:{"datetime":"2022-01-02"}},[_vm._v(_vm._s(item.start_date))]),_vm._v(" "),_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(item.start_date_time))])]),_vm._v(" "),_c('td',{staticClass:"customer-id"},[_c('time',{attrs:{"datetime":"2022-01-02"}},[_vm._v(_vm._s(item.end_date))]),_vm._v(" "),_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(item.end_date_time))])]),_vm._v(" "),_c('td',{staticClass:"customer-phone"},[_vm._v("\n                "+_vm._s(item.services.merchant_name)+"\n                "),_c('br'),_vm._v(" "),_c('i',{staticClass:"text-muted"},[_vm._v(_vm._s(item.services.name))])]),_vm._v(" "),_c('td',{staticClass:"customer-services"},[_vm._v("\n                "+_vm._s(_vm.formatNumber(item.number_of_transactions))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"customer-lastserved"},[_vm._v(_vm._s(item.currency))]),_vm._v(" "),_c('td',{staticClass:"customer-services"},[_vm._v("\n                "+_vm._s(_vm.to_human(item.gross_value || 0))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"customer-services"},[_vm._v("\n                "+_vm._s(_vm.to_human(item.commission || 0))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"customer-services"},[_vm._v("\n                "+_vm._s(_vm.to_human(item.amount || 0))+"\n              ")]),_vm._v(" "),(item.status == 'complete' || item.status == 'settled')?_c('td',{staticClass:"customer-services"},[_c('span',{staticClass:"badge rounded-pill bg-success text-white pt-2 px-3 text-uppercase"},[_vm._v("Settled")])]):_vm._e(),_vm._v(" "),(item.status == 'pending' || item.status == 'generated')?_c('td',{staticClass:"customer-services"},[_c('span',{staticClass:"badge rounded-pill bg-primary text-white pt-2 px-3 text-uppercase"},[_vm._v("Generated")])]):_vm._e(),_vm._v(" "),(item.status == 'generated_settlement_inprogress')?_c('td',{staticClass:"customer-services"},[_c('span',{staticClass:"badge rounded-pill bg-primary text-white pt-2 px-3 text-uppercase"},[_vm._v("Settlement In-progress")])]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"customer-id"},[_c('time',{attrs:{"datetime":"2022-01-02"}},[_vm._v(_vm._s(item.inserted_at))])]),_vm._v(" "),_c('td',{staticClass:"customer-id"},[_vm._v(_vm._s(item.settlement_date))]),_vm._v(" "),_c('td',{staticClass:"customer-id"},[_vm._v(_vm._s(item.payment_methods))]),_vm._v(" "),_c('td',{staticClass:"customer-id"},[_c('a',{attrs:{"href":_vm.get_view(item.id)}},[_vm._v("View Settlement")])])])])})],2),_vm._v(" "),(_vm.total_pages > 1)?_c('div',{staticClass:"card-footer d-flex justify-content-between"},[_c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination"},[(_vm.total_pages > 1 && _vm.current_page > 1)?_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.fetch_settlement_records(_vm.current_page - 1)}}},[_vm._v("Previous")])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"page-item"},[(
                    _vm.total_pages > 1 &&
                    _vm.current_page > 0 &&
                    _vm.current_page < _vm.total_pages
                  )?_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.fetch_settlement_records(_vm.current_page + 1)}}},[_vm._v("Next")]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"page-item d-flex"},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"}},[_vm._v("Page "+_vm._s(_vm.current_page)+" of "+_vm._s(_vm.total_entries))])])])])]):_vm._e()]):_vm._e()])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header mt-md-5"},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"header-pretitle"},[_vm._v("Summary")]),_vm._v(" "),_c('h1',{staticClass:"header-title"},[_vm._v("Settlements Dashboard")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Overview of revenue collections and settlements\n            ")])])])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Reference")]),_vm._v(" "),_c('th',[_vm._v("Start Date")]),_vm._v(" "),_c('th',[_vm._v("End Date")]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',[_vm._v("Applications")]),_vm._v(" "),_c('th',[_vm._v("Currency")]),_vm._v(" "),_c('th',[_vm._v("Gross")]),_vm._v(" "),_c('th',[_vm._v("Commission")]),_vm._v(" "),_c('th',[_vm._v("Net")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Date Submitted")]),_vm._v(" "),_c('th',[_vm._v("Date Settled")]),_vm._v(" "),_c('th',[_vm._v("Payment Method(s)")]),_vm._v(" "),_c('th')])])}]
__vue__options__._scopeId = "data-v-86efe68c"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-86efe68c", __vue__options__)
  } else {
    hotAPI.reload("data-v-86efe68c", __vue__options__)
  }
})()}